export default {
    getHeaderFieldsEprofileTerhesseg: state => state.headerFieldsEprofileTerhesseg,
    getFormActionsEprofileTerhesseg: state => state.formActionsEprofileTerhesseg,
    getActionsEprofileTerhesseg: state => state.actionsEprofileTerhesseg,
    getRowActionsEprofileTerhesseg: state => state.rowActionsEprofileTerhesseg,
    getSearchFields: state => state.searchFields,
    isFormOpenEprofileTerhesseg: state => state.formIsOpen,
    isGridOpenEprofileTerhesseg: state => state.gridIsOpen
}
